import axios from "axios"

export function OrderAPI() {
  function updateCart(lineItemId, quantity) {
    
    const csrfTokenTag = document.querySelector('meta[name=csrf-token]');
    const csrfToken = csrfTokenTag ? csrfTokenTag.content : '';
    let instance = axios.create({ headers: { Accept: 'application/json', 'X-CSRF-Token': csrfToken } })

    return new Promise((resolve, reject) => {
      instance({
        method: "patch",
        url: "/store/cart",
        params: { location: window.location.pathname },
        data: { "order": { "line_items_attributes": {"0": {"quantity": quantity, "id": lineItemId } } } }
      }).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(error)
      })
    })
  }

  function createCart(cartForm) {
    const csrfTokenTag = document.querySelector('meta[name=csrf-token]');
    const csrfToken = csrfTokenTag ? csrfTokenTag.content : '';
    let instance = axios.create({ headers: { Accept: 'application/json', 'X-CSRF-Token': csrfToken } })
    let data = new FormData(cartForm)
    return new Promise((resolve, reject) => {
      instance({
        method: "post",
        url: cartForm.action,
        params: { location: window.location.pathname },
        data: data
      }).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(error)
      })
    })
  }

  function emptyOrder(orderNumber, orderGuestToken) {
    let instance = axios.create({ headers: { "X-Spree-Order-Token": orderGuestToken }})

    instance(
      {
        method: "put",
        url: `/store/api/orders/${orderNumber}/empty`
      }
    ).then(({ data }) => {
      Turbolinks.visit(location.toString())
    }).catch((error) => {
     })

  }

  function removeItem(lineItemId) {
    const csrfTokenTag = document.querySelector('meta[name=csrf-token]');
    const csrfToken = csrfTokenTag ? csrfTokenTag.content : '';
    let instance = axios.create({ headers: {    Accept: 'application/json', 'X-CSRF-Token': csrfToken,}})

    return new Promise((resolve, reject) => {
      instance({
        method: "patch",
        url: "/store/cart",
        params: { location: window.location.pathname },
        data: { "order": { "line_items_attributes": {"0": {"quantity": 0, "id": lineItemId } } } }
      }).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(error)
      })
    })
  }

  function updateOrder(orderId, orderGuestToken, data) {
    let instance = axios.create({ headers: { "X-Spree-Order-Token": orderGuestToken }})

    instance(
      {
        method: "patch",
        url: `/store/api/orders/${orderId}`,
        data: data
      }
    ).then(({ data }) => {
      if(window.location.pathname == "/store/cart") {
        Turbolinks.visit(location.toString())
        return;
      }
      let cartBag = document.querySelector(".shopping-bag-item-count")
      cartBag.innerText = data.total_quantity
    }).catch((error) => { })
  }

  return {
    updateCart,
    emptyOrder,
    createCart,
    removeItem
  }
}
